module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9Tx47"))).then(() => parcelRequire('hEqeo'));